import { ToasterService } from "./../../shared/services/toaster.service";
import { NgForm } from "@angular/forms";
import { Component, OnInit, OnDestroy, Input } from "@angular/core";
import { Router } from "@angular/router";
import { AuthService } from "../services/auth-service.service";
import { TokenManager } from "@app/shared/services/token-manager.service";

@Component({
  selector: "app-auth-comp",
  templateUrl: "./auth-comp.component.html"
})
export class AuthComponent implements OnInit, OnDestroy {
  loading: boolean;
  loginModel: any = {};
  isLoggedIn: boolean;
  constructor(
    private router: Router,
    private auth: AuthService,
    private tokenManager: TokenManager,
    private toasterService: ToasterService
  ) {}

  ngOnInit() {
    document.getElementsByTagName("body")[0].classList.add("loginpage");
    this.tokenManager.deleteToken();
  }

  login(frm: NgForm) {
    this.loading = true;
    this.auth.loginUser(frm.value.username, frm.value.password).subscribe({
      next: response => {
        if (response.success) {
          this.toasterService.Success("Login Successful");
          this.router.navigate(["/dashboard"]);
          this.loading = false;
        }
      },
      error: err => {
        this.loading = false;
        switch (err.status) {
          case 400:
            this.toasterService.Error("Invalid email or password");
            break;

          case 503:
            this.toasterService.Error("Service Unavailable");
            break;

          default:
            this.toasterService.Error("Please try again");
            break;
        }
      }
    });
  }

  ngOnDestroy() {
    document.getElementsByTagName("body")[0].classList.remove("loginpage");
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/auth-comp/auth-comp.component.ts